import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESSES_IDENTITIES_REQUEST = 'BUSINESSES_IDENTITIES_REQUEST'
export const BUSINESSES_IDENTITIES_SUCCESS = 'BUSINESSES_IDENTITIES_SUCCESS'
export const BUSINESSES_IDENTITIES_FAILURE = 'BUSINESSES_IDENTITIES_FAILURE'
export const BUSINESSES_IDENTITIES_RESET = 'BUSINESSES_IDENTITIES_RESET'

export const fetchBusinessIdentitiesById = (id) => ({
  [CALL_API]: {
    endpoint: `/api/business/businesses/${id}/identities/`,
    types: [BUSINESSES_IDENTITIES_REQUEST, BUSINESSES_IDENTITIES_SUCCESS, BUSINESSES_IDENTITIES_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const resetFetchBusinessIdentitiesById = () => ({
  type: BUSINESSES_IDENTITIES_RESET,
})
